module.exports = __webpack_public_path__ + "static/media/footer1.a0cab136.jpeg";